import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCrown } from "react-icons/fa6";
import { FaXmark } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";

export default function SubscriptionModal({ subscriptionModalOpen,setSubscriptionModalOpen }) {
    const navigate = useNavigate();
    if (!subscriptionModalOpen) return null;


    return (

    <div className={`fixed inset-0 bg-black bg-opacity-50 z-[100] items-center justify-center px-5 ${subscriptionModalOpen ? 'flex ' : 'hidden'}`}>
        <div className={` ${subscriptionModalOpen && ' animate-slideOutToUp' } bg-white rounded-2xl shadow-2xl max-w-sm w-full mx-auto mt-20 overflow-hidden`}>
            <div className="bg-gradient-to-r from-orange-500 to-red-500 p-6 text-center relative">
                <button onClick={() => setSubscriptionModalOpen(false)} className="absolute top-4 right-4 text-white text-xl">
                    <FaXmark size={18}></FaXmark>

                </button>
                <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                    <FaCrown className="text-2xl text-white fas fa-crown"></FaCrown>

                </div>
                <h2 className="text-lg font-bold text-white">اشتراک مورد نیاز</h2>
            </div>
            <div className="p-6 text-center">
                <div className="mb-6">
                    <p className="text-gray-700 font-semibold mb-2">دسترسی محدود</p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">برای ایجاد سیگنال و درآمدزایی، می‌بایست اشتراک خود را فعال کنید</p>
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                        <div className="flex flex-row justify-center items-start text-start gap-1 text-yellow-700 text-xs ">
                             <FaStar  className="mr-1 fas fa-star"></FaStar>
                             <p className="flex flex-row items-end justify-end text-end">
                   
                                با اشتراک، سیگنال‌های نامحدود ایجاد کنید</p>
                        </div>
                    </div>
                </div>

                <div className="space-y-3">
                    <button  onClick={() => {navigate(
                        // "/createSignal"
                        "/renew"
                        ) }} className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-200 flex items-center justify-center">
                      
                        <FaCrown className="mr-2 fas fa-crown"></FaCrown>
                        <p className="text-lg ">خرید اشتراک</p>

                    </button>
                    <button onClick={() => setSubscriptionModalOpen(false)} className="w-full border-2 border-gray-300 text-gray-600 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-all duration-200">بستن</button>
                </div>
            </div>
        </div>
    </div>
    );
}
